import SettingsContent from '../Wrapper';
import Index from './Index';
import { frontendURL } from '../../../../helper/URLHelper';
import { requireAuth } from '../../dashboard.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-roles'),
      component: SettingsContent,
      props: {
        headerTitle: 'CUSTOM_ROLES.HEADER',
        icon: 'user-shield',
        showNewButton: true,
      },
      children: [
        {
          path: '',
          name: 'custom_roles_wrapper',
          roles: ['administrator'],
          meta: {
            permissions: ['administrator'],
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'custom_roles_list',
          roles: ['administrator'],
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
          beforeEnter: requireAuth,
        },
      ],
    },
  ],
};
